import { Pipe, PipeTransform } from '@angular/core';
import { AccountGroupLocation } from '@galaxy/account-group';

@Pipe({
  name: 'accountPhone',
})
export class AccountPhonePipe implements PipeTransform {
  transform(account?: AccountGroupLocation): string {
    return account?.workNumber?.[0];
  }
}
